export default __webpack_public_path__ + "static/media/order_management_suppliers.c477d4c3.png";